import { defineStore } from 'pinia';
import { getAdminInfoByTokenApi, adminLogout, adminLoginApi } from '@/api';
import CONSTANTS from '@/utils/constants';
import { addRoutes, permissionsRouteMap } from '@/router';
import util from '@/utils';
import useSystemStore from '@/store/modules/system';

const menuConfig = {
  // common: ['course', 'order', 'appConfig', 'member'],
  // superAdmin: [ 'order', 'appConfig', 'member', 'account'],
  superAdmin: ['course', 'appConfig', 'member', 'apply', 'order', 'account'],
};

// 过滤菜单
const filterMenu = item => {
  if (!item) return null;
  if (item.only) {
    const routeItem = {
      ...item,
      children: null,
    };
    return routeItem;
  }
  if (item.children && item.children.length && !item.menuHide) {
    const routeItem = {
      ...item,
      children: item.children.filter(it => !it.menuHide),
    };
    return routeItem;
  }
  return item;
};

export const useUserStore = defineStore('userInfo', {
  state: () => {
    return {
      userId: null,
      nickName: '',
      deptName: '',
      permissions: [],
      isSuperAdmin: false,
    };
  },
  getters: {
    // 树形菜单
    menus(state) {
      return state.permissions.reduce((prev, key) => {
        const item = filterMenu(permissionsRouteMap[key]);
        item && prev.push(item);
        return prev;
      }, []);
    },
  },
  actions: {
    // 登录
    async loginIn(params) {
      const resp = await adminLoginApi(params);
      const code = resp.code;
      if (code === 200) {
        const token = resp.data.token;
        localStorage.setItem(`${CONSTANTS.TOKEN}`, token);
        this.getUserInfo();
      }
      return resp;
    },
    // 判断是否超管
    judgeIsSuperAdmin() {
      return true;
    },
    // 获取登录用户信息
    async getUserInfo() {
      const systemStore = useSystemStore();
      systemStore.setLoading(true);
      if (this.userInfo) return;
      const resp = await getAdminInfoByTokenApi();
      systemStore.setLoading(false);
      if (resp.code == 200) {
        const userInfo = resp.data;
        this.userId = userInfo.id;
        this.realName = userInfo.realName;
        this.phone = userInfo.phone;
        this.isSuperAdmin = this.judgeIsSuperAdmin();
        this.permissions = this.isSuperAdmin
          ? menuConfig.superAdmin
          : menuConfig.common;
        addRoutes(this.permissions);
      }
    },
    // 清除store
    clearStorage() {
      util.removeLocalStorage(CONSTANTS.TOKEN);
      this.userInfo = null;
    },
    // 登出
    async loginOut() {
      await adminLogout();
      this.clearStorage();
    },
  },
});

export default useUserStore;
